const getClosingStatusPayrollPeriod = `getClosingStatusPayrollPeriod{servicesToReceipts, sendAllToAccounting, closingPeriod}`;

export default getClosingStatusPayrollPeriod;
